<template>
  <div>
    <label class="text-left block">
      <slot></slot>
    </label>
    <div v-if="(options instanceof Array)" class="flex" :class="{
      'flex-row': alignment == 'row',
      'flex-col': alignment == 'col'
    }">
      <label class="mr-2 pr-2 mb-2.5" v-for="item in options" :value="model" :key="item">
        <input type="checkbox" :value="item" v-model="model" @input="updateData(item)"/>
        {{ item }}
      </label>
    </div>

    <div v-else class="flex" :class="{
      'flex-row': alignment == 'row',
      'flex-col': alignment == 'col'
    }">
      <label class="mr-2 pr-2 mb-2.5" v-for="(val, key) in options" :key="key" :value="model">
        <input type="checkbox" :value="key" v-model="model" @input="updateData(key)"/>
        {{ val }}
      </label>

    </div>
  </div>
</template>

<script>
//import { cloneDeep } from 'lodash'

export default {
  props: {
    options: undefined,
    value: [],
    alignment: { type: String, default: 'row' },
    nested: undefined,
  },
  data() {
    return {
      data: [],
    }
  },
  methods: {
    updateData(val) {
      if (this.data.includes(val)) {
        let index = this.data.indexOf(val)
        this.data.splice(index, 1)
      }
      else {
        this.data.push(val)
      }
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
